import { createContext } from "react";

/**
 * Context
 * @type {import("react").Context<import("./types").BankContextI>}
 */
const BankContext = createContext();

export default BankContext;
